import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import { ConvertErrorArrayToString, transactions_type } from "../../Services/Common";
import { setToastData } from "../../Store/reducers/Toast";
import Pagination from "../../Services/Pagination";
import moment from "moment";
import { setMainLoading, setPageTitle } from "../../Store/reducers/Common";
import { Link } from "react-router-dom";

const MyTransactions = () => {
    const dispatch = useDispatch();
    const { userData, accessToken } = useSelector((state) => state.user);
    const [filter, setFilter] = useState({
        transaction_type: 'all'
    });
    const [transactionList, setTransactionList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationData, setPaginationData] = useState({ total: 0, per_page: 20 });
    const [showFilter, setShowFilter] = useState(true);
    const filterHandler = (key, value) => {
        setFilter({ ...filter, [key]: value });
    }
    useEffect(() => {
        dispatch(setPageTitle('Transactions'));
        fetchTransactionList();
    }, [accessToken, dispatch])
    const fetchTransactionList = (pageNo = 0) => {
        dispatch(setMainLoading(true));
        let postData = {
            ...filter
        }
        if (pageNo > 0) {
            postData.page = pageNo
            postData.perPage = paginationData.per_page
        }
        PostAxios(`payments/my-transactions`, postData, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    setPaginationData({ total: data.totalRecords, per_page: data.perPage });
                    setTransactionList(data.data || []);
                }
                else {
                    setPaginationData({ total: 0, per_page: 20 });
                    setTransactionList([]);
                    dispatch(setToastData({ message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                }
            })
            .catch((err) => {
                responseCatchFunc(dispatch, err);
                setTransactionList([]);
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }

    return (
        <div className="main-form-sec">
            {
                (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                <div className="top-reports-filter">
                    <div className={`right-filter-sec`}>
                        <button className="filter-toggle" onClick={() => {
                            setShowFilter(!showFilter);
                        }}>
                            <i className="fa-solid fa-filter"></i>
                        </button>
                        <div className={`p-0 filter-search form-field-group report-filter  ${(showFilter) ? '' : 'filter-active'}`}>

                            <button type="button" className="btn btn-blue ms-2" onClick={() => { setCurrentPage(1); fetchTransactionList(1); }}>Submit</button>
                        </div>
                    </div>
                </div>
            }
            {
                parseInt(userData.id) === 252 && 
                <div className="top-right-btn p-0">
                    <Link
                        to={"/payments/make-payments"}
                        className="btn-blue btn br-0"
                    >
                        Make Payment
                    </Link>
                </div>
            }
            <div className="table-wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            <th>S.No.</th>
                            <th>Transaction ID</th>
                            <th>Type</th>
                            <th>Description</th>
                            <th>Amount</th>
                            <th>Date</th>
                            <th>View Receipt</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            transactionList.length > 0 && transactionList.map((item, index) => {
                                return <tr key={`transaction-id-${index}-${item.id}`}>
                                    <td>{(currentPage - 1) * paginationData.per_page + index + 1}</td>
                                    <td>{item.order_id}</td>
                                    <td>{transactions_type[item.transaction_type]}</td>
                                    <td>{item.transaction_description}</td>
                                    <td><i className="fa-solid fa-indian-rupee-sign"></i> {item.final_amount}</td>
                                    <td>{moment(item.transaction_done_on).format('DD, MMM YYYY hh:mm A')}</td>
                                    <td>
                                        <button type="button" className="btn btn-blue btn-sm">
                                            <i className="fa-regular fa-eye"></i>
                                        </button>
                                    </td>
                                </tr>
                            })
                        }
                    </tbody>
                </table>
            </div>
            <Pagination
                currentPage={currentPage}
                totalCount={paginationData.total}
                pageSize={paginationData.per_page}
                onPageChange={page => {
                    setCurrentPage(page);
                    fetchTransactionList(page);
                }}
            />
        </div>
    )
}

export default MyTransactions